import { ApolloLink } from 'apollo-link';
import _ from 'lodash';
import PENDING from './pendingQueries.graphql';

/**
 * Include or filter out a given operation
 * @param {Apollo Link Operation} operation
 * @returns { Boolean }
 */
const defaultOperationFilter = operation => {
  const isMutation = _.some(
    operation.query.definitions,
    def => def.operation === 'mutation'
  );

  if (isMutation) {
    return false;
  }

  const isNotification = operation.operationName === 'notifications';

  if (isNotification) {
    return false;
  }
  // else
  return true;
};

/**
 * Store and remove records in the cache of current query operations, subject to filter
 * @param {function} operationFilter
 */
const createPendingQueriesLink = (operationFilter = defaultOperationFilter) => {
  const inbound = new ApolloLink((operation, forward) => {
    if (operationFilter(operation)) {
      const key = operation.toKey();
      const { cache } = operation.getContext();
      const previous = cache.readQuery({ query: PENDING });
      const data = {
        pendingQueries: previous.pendingQueries.concat([key]),
      };
      cache.writeData({ data });
    }
    return forward(operation);
  });
  const outbound = new ApolloLink((operation, forward) => {
    return forward(operation).map(result => {
      if (operationFilter(operation)) {
        const key = operation.toKey();
        const { cache } = operation.getContext();
        const previous = cache.readQuery({ query: PENDING });
        const data = {
          pendingQueries: _.reject(previous.pendingQueries, o => o === key),
        };
        cache.writeData({ data });
      }
      return result;
    });
  });
  return inbound.concat(outbound);
};

export default createPendingQueriesLink;
